// extracted by mini-css-extract-plugin
export var closeButton = "_mf-1";
export var closeX = "_mf-3";
export var container = "_mf-0";
export var image = "_mf-2";